<div class="d-flex flex-column">
    <div class="d-flex">
        <label class="f-w-6 mr-4">{{title}} <span *ngIf="isRequired" class="required">(*)</span></label>
        <label (click)="addBold()" class="color-link f-w-6 mr-4 menu">Tô đậm</label>
        <label (click)="openIcon()" class="color-link f-w-6 mr-4 menu">Icon</label>
        <label (click)="openLink()" class="color-link f-w-6 mr-4 menu">Link</label>
        <label (click)="openProduct()" class="color-link f-w-6 mr-4 menu">Sản phẩm</label>
        <label (click)="addImage()" class="color-link f-w-6 mr-4 menu">Hình ảnh</label>
    </div>
    <input id="fileInputEditor" #fileInputEditor style="display: none;" name="file" type="file" ng2FileSelect
        [uploader]="uploader" />
    <add-icon-notificaiton-popup [eventBroadcast]="getIconBroadcast"></add-icon-notificaiton-popup>
    <add-add-link-popup></add-add-link-popup>
    <app-add-product-popup></app-add-product-popup>
    <textarea id="inputDescription" class="form-control" [(ngModel)]="content" (ngModelChange)="changeEditor($event)" rows="5"></textarea>
</div>